//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Routing.js";
let d=[[[0,"ReturnAbsoluteHumidity",1,0],[0,"ReturnAtmosphericPressure",1,0],[0,"ReturnDensity",1,0],[0,"ReturnRelativeHumidity",1,0],[0,"ReturnTemperature",1,0],[0,"ReturnViscosity",1,0],[1,"RouteObjectCollector",0,"Routing.RouteObjectCollector",0],[0,"SupplyAbsoluteHumidity",1,0],[0,"SupplyAtmosphericPressure",1,0],[0,"SupplyDensity",1,0],[0,"SupplyRelativeHumidity",1,0],[0,"SupplyTemperature",1,0],[0,"SupplyViscosity",1,0]],[[[],"CalculateFlowrate",{},0,0],[["selectedObj"],"IsValidHvacSystem",{R_:{errorHvacSystem:''}},1,0],[["selectedObj","flowrateValue"],"SetFlowrate",{},2,0],[[],"GetNumberOfElementsInHvacSystem",{R_:{numberOfElements:''}},0,0],[[],"GetInletFlowrate",{R_:{flowrateValue:''}},0,0],[[],"GetOutletFlowrate",{R_:{flowrateValue:''}},0,0]],[]];
SPLM.MechanicalRouting.FlowAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.FlowAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;